var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"content"},[_vm._t("default"),_c('div',[_c('button',{on:{"click":function($event){return _vm.$emit('clicked')}}},[_c('i',{staticClass:"fal fa-sync"})])])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }